import { render } from "./EditCasinoDetails.vue?vue&type=template&id=2a449e7a&scoped=true"
import script from "./EditCasinoDetails.vue?vue&type=script&lang=js"
export * from "./EditCasinoDetails.vue?vue&type=script&lang=js"

import "./EditCasinoDetails.vue?vue&type=style&index=0&id=2a449e7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a449e7a"]])

export default __exports__